import React from "react";
import PropTypes from "prop-types";
import SearchInput from "../../shared/SearchInput";
import SearchBarWrapper from "../styles/searchVideoForm.style";

function SearchBar(props) {
  const { headerSticky, onScroll, auth, location } = props;

  if (location.pathname.startsWith("/licensing/search")) return null;

  return (
    <SearchBarWrapper scrolling={!headerSticky ? "true" : `${onScroll}`} logged={auth.loggedIn}>
      <SearchInput header />
    </SearchBarWrapper>
  );
}

SearchBar.propTypes = {
  headerSticky: PropTypes.bool,
  onScroll: PropTypes.bool.isRequired,
  auth: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  clearAllSearch: PropTypes.func.isRequired
};

SearchBar.defaultProps = {
  headerSticky: false
};

export default SearchBar;
